// extracted by mini-css-extract-plugin
export default {"baseModal":"baseModal-RCaja","button":"button-gxmm2"};